import { TEAM_MEMBERS } from "../constants/TeamConstant";
import { Link } from "react-router-dom";

const Teams = () => {
  return (
    <div className="home5-team-section sec-mar">
      <div className="container">
        <div className="row g-4 justify-content-center">
          {TEAM_MEMBERS.map(
            ({ name, role, image, description, socialLinks }) => (
              <div
                key={name}
                className="col-xl-3 col-lg-4 col-sm-6 wow animate__animated animate__fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <div className="single-team magnetic-item">
                  <div className="social-area">
                    <ul>
                      {socialLinks.map(({ icon, url }) => (
                        <li key={url}>
                          <Link
                            to={url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className={icon}></i>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="team-img">
                    <img className="img-fluid" src={image} alt={name} />
                  </div>
                  <div className="team-content">
                    <h4>{name}</h4>
                    <span>{role}</span>
                    <p>{description}</p>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Teams;
